var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\xA2\xD0\xB2\xD0\xB8\xD1\x82\xD1\x82\xD0\xB5\xD1\x80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "white_background",
    d: "M30.5192 6.89105C30.5399 7.19137 30.5399 7.49169 30.5399 7.79477C30.5399 17.0299 23.5231 27.6807 10.6924 27.6807V27.6752C6.90221 27.6807 3.19074 26.593 0 24.542C0.551127 24.6084 1.10502 24.6416 1.66029 24.643C4.8013 24.6457 7.85253 23.5898 10.3236 21.6453C7.3387 21.5886 4.72119 19.6386 3.80678 16.7918C4.85241 16.9939 5.9298 16.9524 6.95608 16.6714C3.70181 16.0127 1.36055 13.1479 1.36055 9.82087C1.36055 9.79043 1.36055 9.76136 1.36055 9.7323C2.33021 10.2734 3.41588 10.5737 4.52643 10.607C1.46139 8.55456 0.516596 4.46914 2.3675 1.27498C5.90908 5.64134 11.1344 8.29576 16.7438 8.5767C16.1816 6.14925 16.9496 3.60555 18.7618 1.89914C21.5713 -0.74697 25.99 -0.611343 28.631 2.20223C30.1932 1.89361 31.6905 1.31927 33.0607 0.505505C32.54 2.12334 31.4502 3.49761 29.9943 4.37088C31.377 4.20757 32.7278 3.83667 34 3.27064C33.0635 4.67673 31.8839 5.90153 30.5192 6.89105Z",
    fill: "#512DA8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5cc816662a6b8dff34bf85064beb122d.svg";
export { ForwardRef as ReactComponent };